import { render, staticRenderFns } from "./dealerList.vue?vue&type=template&id=57988e72&scoped=true"
import script from "./dealerList.vue?vue&type=script&lang=js"
export * from "./dealerList.vue?vue&type=script&lang=js"
import style0 from "./dealerList.vue?vue&type=style&index=0&id=57988e72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57988e72",
  null
  
)

export default component.exports